import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { Spin, Row, Col } from 'antd';
import Helmet from 'react-helmet';
import {
  propEq,
  find,
  eqProps,
  ifElse,
  isNil,
  compose,
  join,
  append,
  of,
  prop,
  always,
  isEmpty,
} from 'ramda';
import classNames from 'classnames';
import TruncateMarkup from 'react-truncate-markup';

import { setPageNotFound } from '../../actions/app';
import { releasesByChart } from '../../actions/release';
import { getReleaseList } from '../../components/Pagination';
import SheetTitle from '../../components/SheetTitle';
import { releaseByChartList } from '../../selectors';
import {
  slugify, responsive, smoothScrollTo, isSSR, smoothScroll, releaseTypeToAlt,
} from '../../helpers/view';
import { chartList } from './common';
import BackButton from '../../components/BackButton';

import c from './Chart.less';

function ChartRelease(props) {
  const {
    release, artist, className, position,
  } = props;
  const coverSrc = ifElse(
    compose(isNil, prop('coverUrl')),
    always('https://cvr.mp3caprice.com/covers/no_cover_90.jpg'),
    compose(join('/'), append('90.jpg'), of, prop('coverUrl')),
  )(release);

  return (
    <div className={className}>
      <span className={classNames(c.position, 'visible-desktop')}>
        #{position}
      </span>
      <div className={c.coverWrapper}>
        {
          release.absent ? (
            <img
              alt={`${release.name} mp3 ${releaseTypeToAlt(release.type)} by ${artist.name}`}
              className={c.cover}
              width="90"
              src={coverSrc}
            />
          ) : (
            <Link to={`/release/${slugify(release.name, release.id)}`}>
              <img
                alt={`${release.name} mp3 ${releaseTypeToAlt(release.type)} by ${artist.name}`}
                className={c.cover}
                width="90"
                src={coverSrc}
              />
            </Link>
          )
        }
        <span className={classNames(c.position, 'hidden-desktop')}>
          #<strong>{position}</strong>
        </span>
      </div>
      <div className={c.titles}>

        <div className={c.title}>
          {
            release.absent ? (
              <TruncateMarkup lines={2}><span>{release.name}</span></TruncateMarkup>
            ) : (
              <Link to={`/release/${slugify(release.name, release.id)}`} className={c.releaseLink}>
                <TruncateMarkup lines={2}><span>{release.name}</span></TruncateMarkup>
              </Link>
            )
          }
        </div>
        <div className={c.artist}>by
          <span>
            {
              artist.absent || ['Soundtrack', 'VA_Compilation'].includes(release.type) ? (
                <TruncateMarkup lines={1}><span>{artist.name}</span></TruncateMarkup>
              ) : (
                <Link to={`/artist/${slugify(artist.name, artist.id)}`}>
                  <TruncateMarkup lines={1}><span>{artist.name}</span></TruncateMarkup>
                </Link>
              )
            }
          </span>
        </div>
      </div>
      <div className={c.actions}>
        {
          !release.absent
            ? (
              <Link
                to={`/release/${slugify(release.name, release.id)}`}
                className={c.price}
              >
                $<strong>{release.totalPrice.toFixed(2)}</strong>
              </Link>
            )
            : null
        }
      </div>
    </div>
  );
}

ChartRelease.propTypes = {
  release: PropTypes.object.isRequired,
  artist: PropTypes.object.isRequired,
  className: PropTypes.string,
  loggedId: PropTypes.bool,
  position: PropTypes.number,
};

ChartRelease.defaultProps = {
  className: '',
  loggedId: false,
  position: 0,
};

class ChartList extends Component {
  static propTypes = {
    releasesByChart: PropTypes.func.isRequired,
    setPageNotFound: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    chartReleaseList: PropTypes.object.isRequired,
    releaseList: PropTypes.object.isRequired,
    artistList: PropTypes.object.isRequired,
    app: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
  };

  state = {
    showReleases: false,
  };

  UNSAFE_componentWillMount() {
    const { match: { params: { chartName } } } = this.props;

    if (!chartList.find((chart) => chart.name === chartName)) {
      if (isSSR()) {
        this.props.staticContext.page.status = 404;
      } else {
        this.props.setPageNotFound();
      }
    }
  }

  componentDidMount() {
    if (isEmpty(this.props.chartReleaseList.ids)) {
      this._loadChartData(this.props);
    } else if (this.props.location.state && this.props.location.state.changeTop && this.props.app.renderedComponent !== 'Chart') {
      this.transitToReleases();
    }

    smoothScroll();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { match: { params: { chartName: nextChartName } } } = nextProps;
    const { match: { params: { chartName } } } = this.props;

    if (nextChartName !== chartName) {
      if (isEmpty(nextProps.chartReleaseList.ids)) {
        this._loadChartData(nextProps);
      }
    }

    if (
      responsive.isMobileOrTablet()
      && !nextProps.releaseList.loading
      && (
        !eqProps('loading', nextProps.releaseList, this.props.releaseList)
        || !eqProps('key', nextProps.location, this.props.location)
      )
      && (nextProps.location.state && nextProps.location.state.changeTop)
    ) {
      this.transitToReleases();

      smoothScrollTo(`.${c.releaseListContainer}`);
    }
  }

  handleGoBack = () => {
    this.setState({
      showReleases: false,
    });
  };

  transitToReleases() {
    if (responsive.isMobileOrTablet()) {
      this.setState({
        showReleases: true,
      });
    }
  }

  _loadChartData(props) {
    const chart = find(propEq('name', props.match.params.chartName), chartList);
    this.props.releasesByChart(chart.key);
  }

  selectedChart(field) {
    const { match: { params: { chartName } } } = this.props;

    return chartList.find((chart) => chart.name === chartName)[field];
  }

  render() {
    const {
      chartReleaseList, releaseList, artistList, match: { params: { chartName } },
    } = this.props;
    const { showReleases } = this.state;

    return (
      <div className={c.container}>
        <Helmet defer={false}>
          <title>{`Mp3Caprice - ${this.selectedChart('title')}`}</title>
          <meta
            name="description"
            content={`${this.selectedChart('description')} recommendations on Mp3Caprice. Discover, buy and download fresh tunes for reasonable prices.`}
          />
          <meta property="mc:dp" content={`/catalog/world-chart/${chartName}`} />
          <meta property="mc:page" content="Profile" />
        </Helmet>
        <div className={classNames(c.topSection, { [c.showTops]: !showReleases })} id="chart-list">
          <SheetTitle title="World сharts" className={c.sectionTitle} />
          <Row
            gutter={{
              xs: 16, sm: 16, md: 16, lg: 0,
            }}
            className={c.listContainer}
          >
            {
              chartList.map((chart) => (
                <Col xs={12} lg={4} key={chart.key}>
                  <NavLink
                    activeClassName={c.selectedChart}
                    to={{ pathname: `/chart/${chart.name}`, state: { changeTop: true } }}
                    className={classNames(c.chartItem, c[`chart-${chart.key.toLowerCase()}`])}
                  >
                    <div className={c.logoWrapper}>
                      <img
                        className={c.chartLogo}
                        src={chart.logo}
                        alt={`${chart.key} Logo`}
                      />
                    </div>
                    <span>{chart.header}</span>
                  </NavLink>
                </Col>
              ))
            }
          </Row>
        </div>
        <div className={classNames(c.releaseListContainer, { [c.showReleases]: showReleases })}>
          <Spin size="large" spinning={releaseList.loading}>
            <BackButton onClick={this.handleGoBack} className={c.backButton} />
            <SheetTitle
              title={this.selectedChart('header')}
              className={classNames('hidden-desktop', c.sectionTitle)}
            />
            <ul className={c.releaseList}>
              {
                getReleaseList(chartReleaseList.ids, releaseList, artistList)
                  .map((release, idx) => (
                    <li key={release.id} className={c.releaseItem}>
                      <ChartRelease
                        position={idx + 1}
                        className={c.release}
                        release={release}
                        artist={release.artist}
                      />
                    </li>
                  ))
              }
            </ul>
          </Spin>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store, props) => ({
  app: store.app,
  releaseList: store.releases.list,
  artistList: store.artistList,
  trackList: store.tracks,
  cart: store.shoppingCart.cart,
  user: store.user,
  chartReleaseList: releaseByChartList(store, props, chartList),
});

const mapDispatchToActions = {
  releasesByChart,
  setPageNotFound,
};

export default withRouter(connect(mapStateToProps, mapDispatchToActions)(ChartList));
